import { BasicMoreSettings } from './BasicMoreSettings'
import { PhotoMoreSettings } from './PhotoMoreSettings'
import { CheckboxMoreSettings } from './CheckboxMoreSettings'
import { BarcodeMoreSettings } from './BarcodeMoreSettings'
import { PaymentMoreSettings } from './PaymentMoreSettings'
import { GPSMoreSettings } from './GPSMoreSettings'
import { MirrorMoreSettings } from './MirrorMoreSettings'
import { CalculationMoreSettings } from './CalculationMoreSettings'
import { SummaryMoreSettings } from './SummaryMoreSettings'
import { SignatureMoreSettings } from './SignatureMoreSettings'
import { DrawingMoreSettings } from './DrawingMoreSettings'
import { TextMoreSettings } from './TextMoreSettings'
import { LinkMoreSettings } from './LinkMoreSettings'
import { VideoMoreSettings } from './VideoMoreSettings'
import { NumberMoreSettings } from './NumberMoreSettings'
import { AttachmentMoreSettings } from './AttachmentMoreSettings'

export const getMoreSettings = ({ type }) => {
  const moreSettings = {
    Checkbox: CheckboxMoreSettings,
    Photo: PhotoMoreSettings,
    Barcode: BarcodeMoreSettings,
    Payment: PaymentMoreSettings,
    GPS: GPSMoreSettings,
    Mirror: MirrorMoreSettings,
    Calculation: CalculationMoreSettings,
    Sum: SummaryMoreSettings,
    Signature: SignatureMoreSettings,
    Drawing: DrawingMoreSettings,
    Text: TextMoreSettings,
    'Long Text': TextMoreSettings,
    Link: LinkMoreSettings,
    Video: VideoMoreSettings,
    Number: NumberMoreSettings,
    Attachment: AttachmentMoreSettings,
  }
  return moreSettings[type] || BasicMoreSettings
}
